import calcularComponentesExamen
from "../funciones/calcularComponentesExamen";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import {
	collection,
	getDocs
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

import { useAuth } from "../contextos/AuthContext";

const Contenedor = styled.div`

	position: relative;

	min-height: 100vh;

	padding: 2rem;

	overflow: hidden;

	background:
		radial-gradient(
			circle at top,
			#162032 0%,
			#0b1120 45%,
			#050816 100%
		);

	color: white;

	&::before {

		content: "";

		position: absolute;

		inset: -20%;

		background:
			radial-gradient(
				circle,
				rgba(0,242,255,.08),
				transparent 60%
			);

		filter: blur(80px);

		animation:
			floatAura 12s ease-in-out infinite;
	}

	@keyframes floatAura {

		0% {
			transform:
				translateY(0px)
				translateX(0px);
		}

		50% {
			transform:
				translateY(-30px)
				translateX(20px);
		}

		100% {
			transform:
				translateY(0px)
				translateX(0px);
		}
	}

	&::after {

		content: "";
	
		position: absolute;
	
		inset: 0;
	
		background-image:
			radial-gradient(
				rgba(255,255,255,.16) 1px,
				transparent 1px
			);
	
		background-size:
			90px 90px;
	
		opacity: .12;
	
		animation:
			moveStars 24s linear infinite;
	
		pointer-events: none;
	}

	@keyframes moveStars {

		from {
	
			transform:
				translateY(0px);
		}
	
		to {
	
			transform:
				translateY(90px);
		}
	}
`;

const Card = styled.div`
	max-width: 800px;
	margin: 0 auto;

	background: rgba(255,255,255,0.05);

	border: 1px solid rgba(255,255,255,0.08);

	border-radius: 28px;

	padding: 2rem;
`;

const Titulo = styled.h1`
	font-size: 2.5rem;
	margin-bottom: 2rem;
`;

const Texto = styled.p`
	color: rgba(255,255,255,0.75);
	margin-bottom: 1rem;
`;

const Loader = styled.div`
	min-height: 100vh;

	display: flex;
	align-items: center;
	justify-content: center;

	color: white;
	font-size: 1.2rem;
`;

const BarraContainer = styled.div`
	width: 100%;
	height: 22px;

	background: rgba(255,255,255,0.08);

	border-radius: 999px;

	overflow: hidden;

	margin: 1rem 0 2rem 0;
`;

const Barra = styled.div`
	height: 100%;

	width: ${({ progreso }) => progreso}%;

	background: linear-gradient(
		90deg,
		#5b69e2,
		#7c3aed
	);

	border-radius: 999px;

	transition: 0.4s ease;
`;

const MundosGrid = styled.div`

	position: relative;

	display: flex;

	flex-direction: column;

	gap: 2.2rem;

	max-width: 900px;

	margin: 0 auto;

	padding-top: 2rem;

	&::before {

		content: "";
	
		position: absolute;
	
		left: 50%;
	
		top: 0;
	
		transform: translateX(-50%);
	
		width: 2px;
	
		height: 100%;
	
		background:
			linear-gradient(
				180deg,
				rgba(0,242,255,.05),
				rgba(0,242,255,.18),
				rgba(124,58,237,.12),
				rgba(0,242,255,.05)
			);
	
		filter: blur(1px);
	}
`;

const MundoCard = styled.div`

	position: relative;

	overflow: hidden;

	align-self:
		${({ index }) =>
			index % 2 === 0
				? "flex-start"
				: "flex-end"};

	width: min(100%, 520px);
	
	transform:
	${({ estado }) =>
		estado === "active"
			? "scale(1.03)"
			: "scale(1)"};
	
	border-radius: 30px;

	padding: 1.8rem;

	animation:
		floatWorld 5s ease-in-out infinite;

	min-height: 260px;

	background:
		${({ estado }) => {

			if (estado === "corrupt") {

				return `
					linear-gradient(
						145deg,
						rgba(168,85,247,0.22),
						rgba(239,68,68,0.16)
					)
				`;
			}

			if (estado === "active") {

				return `
					linear-gradient(
						145deg,
						rgba(0,242,255,0.18),
						rgba(91,105,226,0.12)
					)
				`;
			}

			return `
				rgba(255,255,255,0.04)
			`;
		}};

	border:
		1px solid
		${({ estado }) => {

			if (estado === "corrupt") {
				return "rgba(239,68,68,0.35)";
			}

			if (estado === "active") {
				return "rgba(0,242,255,0.35)";
			}

			return "rgba(255,255,255,0.08)";
		}};

	backdrop-filter: blur(14px);

	opacity:
		${({ estado }) =>
			estado === "locked"
				? .58
				: 1};

	transition:
		transform .25s ease,
		box-shadow .25s ease;

	cursor: pointer;

	&:hover {

		border-color:
			rgba(0,242,255,.55);

		transform:
			translateY(-10px)
			scale(1.02);
	
		box-shadow:
			0 24px 60px rgba(0,0,0,.45);
	}

	@keyframes floatWorld {

		0% {
			transform:
				translateY(0px);
		}
	
		50% {
			transform:
				translateY(-8px);
		}
	
		100% {
			transform:
				translateY(0px);
		}
	}
`;

const MundoGlow = styled.div`

	position: absolute;

	mix-blend-mode: screen;

	inset: -20%;

	background:
		radial-gradient(
			circle,
			rgba(0,242,255,.18),
			transparent 70%
		);

	filter: blur(50px);

	opacity:
		${({ estado }) =>
			estado === "active"
				? 1
				: 0.35};

	animation:
		pulseWorld 3.2s ease-in-out infinite;			

		@keyframes pulseWorld {

			0% {
		
				transform:
					scale(1);
		
				opacity:
					.45;
			}
		
			50% {
		
				transform:
					scale(1.08);
		
				opacity:
					1;
			}
		
			100% {
		
				transform:
					scale(1);
		
				opacity:
					.45;
			}
		}
`;

const MundoPath = styled.div`

	box-shadow:
		0 0 18px rgba(0,242,255,.25);

	position: absolute;

	left:
		${({ index }) =>
			index % 2 === 0
				? "92%"
				: "8%"};

	top: -90px;

	width: 5px;

	height: 120px;

	transform: translateX(-50%);

	background:
		linear-gradient(
			180deg,
			rgba(0,242,255,0),
			rgba(0,242,255,.45),
			rgba(124,58,237,.35),
			rgba(0,242,255,0)
		);

	filter: blur(1px);

	opacity: .85;

	pointer-events: none;
`;

const MundoNombre = styled.h2`

	position: relative;

	font-size: 1.5rem;

	font-weight: 900;

	margin-bottom: .6rem;

	letter-spacing: .4px;

	text-shadow:
		0 0 20px rgba(0,242,255,.18);
`;

const MundoDescripcion = styled.p`

	position: relative;

	color: rgba(255,255,255,.72);

	line-height: 1.5;

	margin-bottom: 1.5rem;

	font-size: .96rem;
`;

const MundoStats = styled.div`

	position: relative;

	display: flex;

	flex-wrap: wrap;

	gap: .7rem;
`;

const MundoBadge = styled.div`

	padding: .55rem .9rem;

	border-radius: 999px;

	background:
		rgba(255,255,255,.08);

	font-size: .88rem;

	font-weight: 700;
`;

const MundoEstado = styled.div`

	position: absolute;

	top: 18px;
	right: 18px;

	font-size: 1.8rem;
`;

const RegionesList = styled.div`

	position: relative;

	display: flex;

	flex-wrap: wrap;

	gap: .55rem;

	margin-top: 1.4rem;
`;

const RegionTag = styled.div`

	padding: .45rem .75rem;

	border-radius: 999px;

	font-size: .78rem;

	background:
		rgba(255,255,255,.08);

	color:
		rgba(255,255,255,.82);

	border:
		1px solid rgba(255,255,255,.06);
`;

const MundoFooter = styled.div`

	position: relative;

	margin-top: 1.8rem;

	display: flex;

	align-items: center;

	justify-content: space-between;

	gap: 1rem;
`;

const MissionBox = styled.div`

	position: relative;

	margin-top: 1.4rem;

	padding: 1rem 1.1rem;

	border-radius: 18px;

	background:
		rgba(255,255,255,.06);

	border:
		1px solid rgba(255,255,255,.08);

	font-size: .92rem;

	line-height: 1.45;

	color:
		rgba(255,255,255,.84);
`;

const ExplorarBtn = styled.button`

	border: none;

	padding: .85rem 1.1rem;

	border-radius: 16px;

	font-weight: 800;

	cursor: pointer;

	color: white;

	position: relative;

	overflow: hidden;

	background:
		linear-gradient(
			135deg,
			#5b69e2,
			#7c3aed
		);

	transition:
		transform .2s ease,
		box-shadow .2s ease;

		&::before {

			content: "";
		
			position: absolute;
		
			top: 0;
		
			left: -120%;
		
			width: 100%;
		
			height: 100%;
		
			background:
				linear-gradient(
					90deg,
					transparent,
					rgba(255,255,255,.25),
					transparent
				);
		
			transition: .6s ease;
		}
		
		&:hover::before {
		
			left: 120%;
		}

	&:hover {

		transform:
			translateY(-2px);

		box-shadow:
			0 10px 24px rgba(91,105,226,.35);
	}
`;

const CorrupcionBar = styled.div`

	width: 100%;

	height: 10px;

	border-radius: 999px;

	overflow: hidden;

	background:
		rgba(255,255,255,.08);

	margin-top: 1.3rem;
`;

const CorrupcionFill = styled.div`

	height: 100%;

	width:
		${({ value }) => value}%;

	background:
		linear-gradient(
			90deg,
			#22c55e,
			#facc15,
			#ef4444
		);

	transition: .4s ease;
`;

const MisMetas = () => {

	const { usuario } = useAuth();
	const [data, setData] = useState(null);
	const [mundos, setMundos] = useState([]);
	const [loading, setLoading] = useState(true);
	const [componentes, setComponentes] =
	useState({});

	useEffect(() => {

		const cargar = async () => {

			if (!usuario) return;

			const componentesExamen =
				await calcularComponentesExamen(
					usuario.uid
				);

			console.log(
				"COMPONENTES:",
				componentesExamen
			);
		
			const metasSnap = await getDocs(
				collection(db, "metas")
			);
			
			const metas =
				metasSnap.docs.map((d) => ({
					id: d.id,
					...d.data()
				}));
			
			console.log("METAS:");
			console.log(metas);

			const rutasSnap =
	await getDocs(
		collection(
			db,
			"rutas_estudio"
		)
	);

const rutaActiva =
	rutasSnap.docs.find(
		doc => {

			const data =
				doc.data();

			return (
				data.userId ===
				usuario.uid
				&&
				data.activa === true
			);
		}
	);
			const snap = await getDocs(
				collection(db, "progreso_metas")
			);
		
			const docs = snap.docs
				.map((d) => d.data())
				.filter(
					(d) =>
						d.userId === usuario.uid
				);

				const examenActivo =
				rutaActiva?.data()
					?.examenObjetivo
					?.toLowerCase();
					
					const diasRestantes =
					rutaActiva?.data()
						?.diasRestantes || 0;
				
				const estadoViabilidad =
					rutaActiva?.data()
						?.estadoViabilidad || "";
				
				const fechaObjetivo =
					rutaActiva?.data()
						?.fechaObjetivo || "";	
		
						const cronograma =
						rutaActiva?.data()
							?.cronograma || [];
			
			const total = {
		
				nivel: 1,
		
				rango: "Hierro",
		
				corrupcion: 0,
		
				mejor_streak: 0,
		
				preguntas_correctas: 0,
		
				preguntas_respondidas: 0,
		
				materiasStats: {}
			};
		
			docs.forEach((d) => {
		
				total.nivel =
					Math.max(
						total.nivel,
						d.nivel || 1
					);
		
				total.corrupcion =
					Math.max(
						total.corrupcion,
						d.corrupcion || 0
					);
		
				total.mejor_streak =
					Math.max(
						total.mejor_streak,
						d.mejor_streak || 0
					);
		
				total.rango =
					d.rango || "Hierro";
		
				total.preguntas_correctas +=
					d.preguntas_correctas || 0;
		
				total.preguntas_respondidas +=
					d.preguntas_respondidas || 0;
		
				const materias =
					d.materiasStats || {};
		
				Object.entries(materias)
					.forEach(([k, v]) => {
		
						if (
							!total.materiasStats[k]
						) {
		
							total.materiasStats[k] = {
		
								correctas: 0,
		
								incorrectas: 0,
		
								noEntendidas: 0
							};
						}
		
						total.materiasStats[k]
							.correctas +=
							v.correctas || 0;
		
						total.materiasStats[k]
							.incorrectas +=
							v.incorrectas || 0;
		
						total.materiasStats[k]
							.noEntendidas +=
							v.noEntendidas || 0;
					});
			});
		
			const mundosConstruidos =
	metas
	.filter(
		meta =>
			meta.codigo ===
			examenActivo
	)
	.map((meta) => {

					const examenIdPorCodigo = {

						icfes: 1,
					
						unal: 2,
					
						udea: 3
					};
					
					const infoComponentes =
						componentesExamen[
							examenIdPorCodigo[
								meta.codigo
							]
						];
						const componentesLista =
						infoComponentes
							? Object.values(
								infoComponentes.componentes
							)
							: [];
							const regionesExploradas =
							componentesLista.filter(
								c =>
									c.temasExplorados > 0
							).length;
							const regionesEvaluadas =
							componentesLista.filter(
								c =>
									c.temasEvaluados > 0
							).length;	
							const regionesCriticas =
								componentesLista.filter(
									c =>
										c.estado === "critico"
								).length;		

					const progreso =
						docs.find(
							(d) =>
								d.metaId === meta.codigo
						);

					const correctas =
						progreso?.preguntas_correctas || 0;

					const respondidas =
						progreso?.preguntas_respondidas || 0;

					const precision =
						respondidas > 0
							? Math.round(
								(correctas / respondidas) * 100
							)
							: 0;

					const corrupcion =
						progreso?.corrupcion || 0;

					let estado = "locked";

					if (respondidas > 0) {
						estado = "active";
					}

					if (corrupcion >= 60) {
						estado = "corrupt";
					}

					return {

						...meta,

						estadisticasAcademicas: {

							regionesExploradas,
						
							regionesEvaluadas,
						
							regionesCriticas
						},

						progreso: {

							nivel:
								progreso?.nivel || 1,

							xp:
								progreso?.xp || 0,

							correctas,

							respondidas,

							precision,

							corrupcion
						},

						estado
					};
				});

			console.log("MUNDOS:");
			console.log(mundosConstruidos);

			setComponentes(
				componentesExamen
			);			
			setMundos(mundosConstruidos);
			setData({

				...total,
			
				diasRestantes,
			
				estadoViabilidad,
			
				fechaObjetivo,
			
				examenActivo,
			
				cronograma
			});

			setLoading(false);

		};

		cargar();

	}, [usuario]);

	if (loading) {

		return (
			<Loader>
				Cargando portal...
			</Loader>
		);
	}

	if (!data) {

		return (
			<Contenedor>
				<Card>
					<Titulo>🌌 Mis Metas</Titulo>

					<Texto>
						Aún no tienes progreso registrado.
					</Texto>
				</Card>
			</Contenedor>
		);
	}

	const precision =
	data.preguntas_respondidas > 0
		? Math.round(
			(data.preguntas_correctas /
			data.preguntas_respondidas) * 100
		)
		: 0;

	const xp = data.xp || 0;

	const xpSiguienteNivel =
		data.xp_siguiente_nivel || 100;
	
	const progresoXp = Math.round(
		(xp / xpSiguienteNivel) * 100
	);

	let colorCorrupcion = "#22c55e";

	if (data.corrupcion >= 30) {
		colorCorrupcion = "#facc15";
	}
	
	if (data.corrupcion >= 60) {
		colorCorrupcion = "#f97316";
	}
	
	if (data.corrupcion >= 80) {
		colorCorrupcion = "#ef4444";
	}	

	return (
		<Contenedor>

			<div
				style={{

					position: "relative",

					maxWidth: "900px",

					margin: "0 auto 2.5rem auto",

					zIndex: 10
				}}
			>

				<h1
					style={{

						fontSize:
							"clamp(2.4rem, 7vw, 4.2rem)",

						fontWeight: 900,

						marginBottom: ".8rem"
					}}
				>
					🌌 Mapa de Mundos
				</h1>

				<p
					style={{

						color:
							"rgba(255,255,255,.72)",

						fontSize: "1.05rem",

						lineHeight: 1.6,

						maxWidth: "760px"
					}}
				>

					Cada mundo representa una ruta
					de entrenamiento académico.
					Mejora tu precisión, estabiliza
					la corrupción y domina nuevas regiones.

				</p>

				<div
	style={{

		marginTop: "1.5rem",

		padding: "1rem",

		borderRadius: "16px",

		background:
			"rgba(255,255,255,.06)",

		maxWidth: "700px"
	}}
>

	<div>

		📅 Fecha objetivo:
		{" "}
		{data.fechaObjetivo}

	</div>

	{
	data.cronograma?.length > 0 && (

		<div
			style={{

				marginTop: "1rem",

				padding: "1rem",

				borderRadius: "16px",

				background:
					"rgba(255,255,255,.06)",

				maxWidth: "700px"
			}}
		>

			<h3>

				📅 Próxima semana

			</h3>

			<p>

				Semana:
				{" "}
				{
					data.cronograma[0]
						?.semana
				}

			</p>

			<p>

				Horas:
				{" "}
				{
					data.cronograma[0]
						?.horas
				}

			</p>

			<p>

				Temas planificados:
				{" "}
				{
					data.cronograma[0]
						?.temas
						?.length || 0
				}

			</p>

		</div>
	)
}

	<div
		style={{
			marginTop: ".5rem"
		}}
	>

		⏳ Días restantes:
		{" "}
		{data.diasRestantes}

	</div>

	<div
		style={{
			marginTop: ".5rem"
		}}
	>

		{
			data.estadoViabilidad ===
			"verde"

			?

			"🟢 Preparación completa viable"

			:

			data.estadoViabilidad ===
			"amarillo"

			?

			"🟡 Ruta priorizada"

			:

			data.estadoViabilidad ===
			"rojo"

			?

			"🔴 Repaso estratégico"

			:

			"⚫ Sin clasificación"
		}

	</div>

</div>

			</div>

			<MundosGrid>

			{mundos.map((mundo, i) => {

				const iconoEstado =
					mundo.estado === "corrupt"
						? "☣️"
						: mundo.estado === "active"
						? "🌌"
						: "🔒";

				return (

					<MundoCard
						index={i}
						key={mundo.codigo}
						estado={mundo.estado}
					>
						<MundoPath index={i} />

						<MundoGlow
							estado={mundo.estado}
						/>

						<MundoEstado>
							{iconoEstado}
						</MundoEstado>

						<MundoNombre>
							{mundo.nombre}
						</MundoNombre>

						<MundoDescripcion>
							{mundo.descripcion}
						</MundoDescripcion>

						<MundoStats>

							<MundoBadge>
								🧠 Nv.
								{" "}
								{mundo.progreso.nivel}
							</MundoBadge>

							<MundoBadge>
								⚡
								{" "}
								{mundo.progreso.xp} XP
							</MundoBadge>

							<MundoBadge>
	🗺️
	{" "}
	{mundo.estadisticasAcademicas
		?.regionesExploradas || 0}
	{" "}
	regiones
</MundoBadge>

<MundoBadge>
	👑
	{" "}
	{mundo.estadisticasAcademicas
		?.regionesEvaluadas || 0}
	{" "}
	conquistadas
</MundoBadge>

						</MundoStats>

						<RegionesList>

							{mundo.regiones
								?.slice(0, 4)
								.map((r, i) => (

									<RegionTag key={i}>
										{r}
									</RegionTag>
								))}

						</RegionesList>

						<CorrupcionBar>

							<CorrupcionFill
								value={
									mundo.progreso.corrupcion
								}
							/>

							</CorrupcionBar>

							<MissionBox>

								{mundo.estado === "locked" &&
									"🔒 Completa otros mundos para desbloquear esta ruta."}

								{mundo.estado === "active" &&
									`🎯 Próxima misión: conquista una nueva región.`}

								{mundo.estado === "corrupt" &&
									"⚡ El conocimiento se está olvidando. Recupera energía."}

							</MissionBox>

							{
	mundo.codigo ===
	data.examenActivo && (

		<div
			style={{

				marginTop: "1rem",

				padding: ".75rem",

				borderRadius: "12px",

				background:
					"rgba(0,242,255,.12)"
			}}
		>

			🎯 Ruta activa

		</div>
	)
}

							<MundoFooter>

							<div>

	⚡ Energía:
	{" "}
	{100 - (mundo.progreso.corrupcion || 0)}%

</div>

							<ExplorarBtn
								onClick={() =>
									window.location.href =
										`/meta/${mundo.codigo}`
								}
							>
								🗺️ Explorar Mundo
							</ExplorarBtn>

						</MundoFooter>
					</MundoCard>
				);
			})}

			</MundosGrid>

		</Contenedor>
	);
};

export default MisMetas;